import { ModalType } from '../../../Framework/Components/Modals/ModalTypes';
import Modal from '../../../Framework/Components/Modals/Modal';
import Button from '../../../Framework/Components/Buttons/Button';
import { ColourMod, FlexAlign, FlexGap, FlexJustify } from '../../../Framework/Data/Enums/LayoutEnums';
import { SendDataProcess } from '../StandaloneSendForm';
import StackVertical from '../../../Framework/Components/Wrappers/StackVertical';

import sendStart from '../../../Components/Animations/send-start.json';
import sendProcess from '../../../Components/Animations/send-process.json';
import sendEnd from '../../../Components/Animations/send-end.json';

import Lottie from 'lottie-react';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';

interface SendUploadModalType extends ModalType {
	sendData?: SendDataProcess;
	uploadStartedCallback?: any;
	saveSendStartedCallback?: any;
}

const SendProcessingWizardModal = (props: SendUploadModalType) => {
	const [startAnimationComplete, setStartAnimationComplete] = useState<boolean>(false);
	const [processAnimationComplete, setProcessAnimationComplete] = useState<boolean>(false);
	const [endAnimationComplete, setEndAnimationComplete] = useState<boolean>(false);

	return (
		<Modal
			title={'Send Item'}
			lockOpen={props.lockOpen}
			isOpen={props.isOpen}
			closeCallback={() => props.closeCallback()}
		>
			<StackVertical gap={FlexGap.Small} extraClass={endAnimationComplete ? 'sends-complete-shifter' : ''}>
				{/*
				{!props.sendData?.postingData && (
					<>
						<object
							data={URL.createObjectURL(props.sendData?.form?.file[0])}
							type='application/pdf'
							style={{ width: '100%', aspectRatio: '1/1.414' }}
						/>
						<div className={'mt-md'}>
							<h6 className={'m-0'}>Recipient</h6>
							<p>{props.sendData?.address}</p>

							<h6 className={'m-0'}>Postage</h6>
							<p>{props.sendData?.postage}</p>
						</div>
					</>
				)}

				{!props.sendData?.postingData && !props.sendData?.sendComplete && (
					<Button
						title={'Looks Good, Send!'}
						fullWidth={true}
						colour={ColourMod.Primary}
						onClick={() => props.actionedCallback()}
					/>
				)}
*/}
				{(props.sendData?.uploadFileActive ||
					props.sendData?.sendDataActive ||
					props.sendData?.sendComplete) && (
					<StackVertical justify={FlexJustify.Center} gap={FlexGap.Small} align={FlexAlign.Center}>
						<div className={'animation-framer'} style={{ margin: '10em' }}>
							{!startAnimationComplete && (
								<Lottie
									animationData={sendStart}
									loop={false}
									onComplete={() => setStartAnimationComplete(true)}
								/>
							)}

							{startAnimationComplete && !processAnimationComplete && (
								<Lottie
									animationData={sendProcess}
									loop={true}
									onLoopComplete={() => {
										if (!props.sendData?.uploadFileActive && props.sendData?.sendComplete) {
											setProcessAnimationComplete(true);
										}
									}}
								/>
							)}

							{processAnimationComplete && (
								<Lottie
									animationData={sendEnd}
									loop={false}
									onComplete={() => setEndAnimationComplete(true)}
								/>
							)}
						</div>

						<div className={'send-complete-info'}>
							<h5 className={'text-center mb-xs'}>Success</h5>
							<p className={'text-center mb-xl'}>Your file will be posted shortly!</p>

							<div className={'row'}>
								<div className={'col-center col-center-md-6'}>
									{props.sendData.trackingId && (
										<a
											href={`${process.env.REACT_APP_CLIENT_HOST}/Mail#/mail/${props.sendData.trackingId}`}
											target={'_blank'}
											className={'btn interactive btn-block primary mb-lg'}
											rel='noreferrer'
										>
											Open Send
										</a>
									)}
								</div>
							</div>

							<StackVertical gap={FlexGap.ExtraSmall}>
								<Button
									title={'Close'}
									fullWidth={true}
									colour={ColourMod.Secondary}
									onClick={() => props.closeCallback()}
								/>
							</StackVertical>
						</div>
					</StackVertical>
				)}
			</StackVertical>
		</Modal>
	);
};

export default SendProcessingWizardModal;
